import React from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
// Data
import {
  errorPageAdditionalMeta,
  errorPageStructuredData,
} from '../../utils/data/MetaData';
// Images
import GemLogoPng from '../../assets/images/logos/diamond-gem-mistress-jewell-icon.png';
// Constants
import { CompanyName } from '../../utils/Constants';

function Error404() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Error'
        desc='The requested page could not be found. Visit our homepage to find what you’re looking for.'
        additionalMeta={errorPageAdditionalMeta}
        structuredData={errorPageStructuredData}
      />

      {/* Page */}
      <div className='grid relative min-h-screen font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        {/* Gem */}
        <img
          src={GemLogoPng}
          alt={`Diamond glowing icon for ${CompanyName}`}

          className='hidden md:block md:min-w-24 md:max-w-48 md:top-4 lg:top-[12rem] lg:left-[4%] lg:min-w-60 xl:min-w-[500px] absolute -rotate-12 opacity-60'
        />
        <div className='grid h-full max-h-screen w-full overflow-hidden'>
          {/* Navigation */}
          <Navbar />

          {/* Main page content */}
          <main
            role='main'
            className='relative grid w-full h-full overflow-hidden items-center'
          >
            <section className='grid w-full text-center h-full items-center justify-center z-10'>
              <section className='grid gap-2 px-2'>
                <article className='outline outline-2 text-black dark:text-black font-semibold outline-black dark:outline-black -mt-10 rounded bg-colour1 dark:bg-colour1'>
                  <div className='p-4'>
                    <h1 className='text-2xl lg:text-4xl text-left'>
                      ERROR <span className='text-red-500'>404</span>
                    </h1>
                    <h2 className='text-2xl lg:text-4xl'>PAGE NOT FOUND</h2>
                  </div>
                  <article className='text-red-500 text-left pl-4 border-t-2 border-solid border-black dark:border-black p-2'>
                    <h3 className='uppercase'>Go back and see your Mistress</h3>
                  </article>
                </article>
              </section>
            </section>
          </main>
        </div>
      </div>
    </>
  );
}

export default Error404;
